import { fetchPsap } from '@rsos/reduxDataStore/src/features/capstone/psapInfo/psapInfoSlice';
import { fetchUser, setTokens, postAuthTokenSuccess } from '@rsos/sinatra';
import { getUrlParameter } from '@rsos/utils';
import { configureUserScope } from '@rsos/utils/sentry';
import {
  APP_INIT_START,
  APP_INIT_SUCCESS,
  APP_INIT_FAILED,
} from '../actions/actionTypes';

export const appInitStart = () => ({
  type: APP_INIT_START,
});

export const appInitSuccess = () => ({
  type: APP_INIT_SUCCESS,
});

export const appInitFailed = error => ({
  type: APP_INIT_FAILED,
  error,
});

const SESSION_EXPIRED_QUERY_PARAM = '?session_expired=true';

const hardRedirect = to => {
  window.location = to;
};

const initialize = () => (dispatch, store) => {
  dispatch(appInitStart());
  const isLoggedIn = store().sinatra.user.isLoggedIn;

  const accessToken = getUrlParameter('access_token');
  if (accessToken) {
    const tokens = {
      refresh_token: null,
      token: accessToken,
    };
    setTokens(tokens);
    dispatch(postAuthTokenSuccess(tokens));
  }

  return dispatch(fetchUser())
    .then(user => {
      if (user && user.profile) {
        configureUserScope(user.profile);
      }

      const { sinatra } = store();
      const currentApp = sinatra.user.currentRole.application;
      const org = sinatra.user.currentOrg;
      const foundOrg = org.roles.find(role => role.application === currentApp);

      if (foundOrg.permissions.includes('MANAGE_AGENCY_INFO')) {
        return dispatch(fetchPsap(`/psaps/${org.name}`));
      } else {
        throw new Error('User does not have permissions to access');
      }
    })
    .then(() => dispatch(appInitSuccess()))
    .catch(action => {
      const isRefreshTokenExpired = Boolean(action?.isRefreshTokenExpired);

      // Only redirect with session-expired UX when refresh-token renewal failed.
      if (isLoggedIn && isRefreshTokenExpired) {
        return hardRedirect(`/${SESSION_EXPIRED_QUERY_PARAM}`);
      }

      if (isLoggedIn) {
        if (action.error) {
          return dispatch(appInitFailed(action.error));
        }
        return dispatch(appInitFailed(action));
      }

      return hardRedirect('/');
    });
};

export default initialize;
